import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/desc-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-8625c308")

_pushScopeId("data-v-8625c308")
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "banner" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("h3", { class: "about-title left" }, [
      /*#__PURE__*/_createTextVNode("关于小芒"),
      /*#__PURE__*/_createVNode("span", { class: "title-bg" }, "ABOUT XIAO MANG")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "desc-content bolder" }, " 小芒APP是湖南广电旗下全新内容电商平台，通过将芒果的内容能力和IP优势延续到电商领域，以多元化盈利模式拓宽了内容产业链的变现模式。 "),
    /*#__PURE__*/_createVNode("p", { class: "desc-content" }, " 小芒APP于2021年1月1日正式上线运营。小芒通过聚焦Z世代用户，深入挖掘IP资源价值，探索全新内容电商模式，从独特内容、独特商品、独特运营切入，打通从IP流量到商品销量的转化链路，解决IP商业化变现的核心业务命题。 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "desc-img" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "brand" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "about-title" }, "合作品牌", -1)
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "about-title" }, "联系我们", -1)
const _hoisted_8 = {
  class: "contact-map",
  ref: "map$"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"addr\" data-v-8625c308><div data-v-8625c308><p class=\"addr-item\" data-v-8625c308><span class=\"addr-item-title\" data-v-8625c308>招商邮箱：</span> zhaoshang@mgtv.com </p><p class=\"addr-item\" data-v-8625c308><span class=\"addr-item-title\" data-v-8625c308>招聘邮箱：</span> hr@mgtv.com </p><p class=\"addr-item\" data-v-8625c308><span class=\"addr-item-title\" data-v-8625c308>服务热线：</span> 400-9770-707 </p><p class=\"addr-item\" data-v-8625c308><span class=\"addr-item-title\" data-v-8625c308>办公地址：</span> 湖南省长沙市开福区广电路湖南广电大楼 </p></div><div class=\"qrcode\" data-v-8625c308><div class=\"qrcode-download\" data-v-8625c308>下载小芒APP</div><div class=\"qrcode-wx\" data-v-8625c308>关注微信小程序</div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_swiper, {
        class: "brand-swiper",
        autoplay: "",
        pagination: {
          clickable: true
        }
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Math.ceil(_ctx.brandList.length / 15), (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              class: "brand-swiper-slide",
              key: item
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.brandList.slice((item - 1) * 15, item * 15), (v, i) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "brand-item",
                    key: i
                  }, [
                    _createVNode("img", {
                      src: v,
                      alt: ""
                    }, null, 8, ["src"])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, null, 512),
      _hoisted_9
    ])
  ]))
})